module.exports = __webpack_public_path__ + "img/ORGANIGRAMA-MARZO-2025.2fc0f1ab.png";